import { useCallback } from 'react';

import { TServerSendResponse } from '../../types';
import { useGenericSend } from '../useGenericSend';
import * as Types from './types';

export const useOptInFromBonusTemplate = () => {
    const send = useGenericSend();

    return useCallback(async (request: Types.IOptInFromBonusTemplateRequestData): Promise<TServerSendResponse> => {
        const { data } = await send<Types.IOptInFromBonusTemplateRequestData, TServerSendResponse>({
            ID: 31091,
            responses: [31092, 31093],
            description: 'Opt in to bonus template',
            errorLevel: 1,
            ...request
        });

        return data;
    }, [
        send
    ]);
};
